/**
 * 语言配置（单一配置点）
 *
 * 支持语言：en / ja / ko / de / zh-TW（OPT-005，简中已下线）
 * ★ 改默认语言只需改同目录 config.json 的 defaultLanguage 这一处
 *   （server 侧 rootDir 限制无法直接 import 本 ts，经 server/src/lib/i18nConfig.ts 读同一 config.json）
 *
 * 前端 i18n 初始化与服务端邮件语言解析共用同一份配置数据。
 */

import configJson from './config.json'

export const SUPPORTED_LANGUAGES = configJson.supportedLanguages as unknown as readonly ['en', 'ja', 'ko', 'de', 'zh-TW']
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

/** 默认语言（繁中）。后期改默认英文时在 config.json 改为 'en' 即可 */
export const DEFAULT_LANGUAGE = configJson.defaultLanguage as SupportedLanguage

/** 简中及其别名统一映射到繁中（简中已下线，存量偏好回退） */
const ZH_ALIASES = new Set(['zh', 'zh-cn', 'zh-hans', 'zh-sg', 'zh-tw', 'zh-hant', 'zh-hk', 'zh-mo'])

/**
 * 任意输入（localStorage 偏好 / Accept-Language / navigator.language）→ 合法语言
 * - zh 系列一律归一到 zh-TW
 * - en-US / ja-JP 等取主 tag
 * - 空值或不支持 → DEFAULT_LANGUAGE
 */
export function normalizeLanguage(input: string | null | undefined): SupportedLanguage {
  if (!input) return DEFAULT_LANGUAGE
  const primary = input.trim().toLowerCase().split(',')[0].split(';')[0].replace(/_/g, '-')
  const mainTag = primary.split('-')[0]
  if (ZH_ALIASES.has(primary) || mainTag === 'zh') return 'zh-TW'
  for (const lang of SUPPORTED_LANGUAGES) {
    if (mainTag === lang.toLowerCase()) return lang
  }
  return DEFAULT_LANGUAGE
}
